<div class="course-summary">
  <h3 class="course-summary__title">
    {{ courseName() }}
    @if (withEditButton()) {
    <button
      class="course-summary__edit-button"
      type="button"
      aria-label="Edit"
      [lxGAClickEvent]="gaEvent()"
      (click)="onEditClick.emit()"
      data-qa="courseSummary_edit_button"
    >
      <img ngSrc="assets/images/pencil.svg" alt="Edit" height="12" width="12" />
      <span i18n>Edit</span>
    </button>
    }
  </h3>
  <p class="course-summary__duration">{{ startDate() | lxStudyPeriod : endDate() : duration() : DurationUnitEnum.WEEKS }}</p>

  @if (benefits() && benefits()!.length > 0) {
  <div class="course-summary__included">
    <div class="course-summary__included__title" i18n>Included in your course</div>
    <ul class="course-summary__included__list">
      @for (item of benefits(); track item) {
      <li class="course-summary__included__list__item">
        <div class="course-summary__included__list__item__icon"></div>
        {{ item }}
      </li>
      }
    </ul>
  </div>
  }

  <div class="course-summary__total-price" [class.course-summary__total-price--calculating]="!priceAvailable()">
    @if (priceAvailable()) {
    <div class="course-summary__total-price__label-container">
      <div class="course-summary__total-price__label" i18n>Total price</div>
    </div>
    <div class="course-summary__total-price__price">
      <span class="course-summary__total-price__amount"> {{ grandTotal() | lxPrice : { currency: currency(), showCurrency: false } }} </span>
      <span class="course-summary__total-price__currency">{{ currency() }}</span>
    </div>
    } @else {
    <div class="course-summary__total-price__calculating-message" i18n>Calculating price...</div>
    }
  </div>
</div>
